import { Link } from "react-router-dom";
import ProtectedEmail from "@/components/ProtectedEmail";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/[0.06] bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <span className="w-7 h-7 rounded-md bg-gradient-to-br from-white/15 to-white/[0.02] border border-white/10 flex items-center justify-center">
                <span className="text-[10px] font-mono text-white/90">GM</span>
              </span>
              <span className="font-display text-base text-white">
                Grayscale <span className="text-zinc-500">Media</span>
              </span>
            </Link>
            <p className="mt-5 text-sm text-zinc-500 max-w-sm leading-relaxed">
              Moderne Websites für Unternehmen mit Anspruch — entwickelt in
              Thüringen.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 font-semibold">
              Studio
            </div>
            <ul className="mt-4 space-y-2 text-sm text-zinc-400">
              <li><a href="#leistungen" className="hover:text-white transition-colors">Leistungen</a></li>
              <li><a href="#arbeiten" className="hover:text-white transition-colors">Arbeiten</a></li>
              <li><a href="#prozess" className="hover:text-white transition-colors">Prozess</a></li>
              <li><a href="#kontakt" className="hover:text-white transition-colors">Kontakt</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 font-semibold">
              Rechtliches
            </div>
            <ul className="mt-4 space-y-2 text-sm text-zinc-400">
              <li>
                <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-white transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-white transition-colors">
                  Datenschutz
                </Link>
              </li>
              <li className="pt-2">
                <ProtectedEmail
                  variant="inline"
                  testId="footer-email"
                  className="text-sm text-zinc-500 hover:text-white transition-colors"
                />
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/[0.06] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-zinc-600">© {year} Grayscale Media. Alle Rechte vorbehalten.</p>
          <p className="text-xs text-zinc-600 font-mono">
            Mit Sorgfalt gebaut in <span className="text-zinc-400">Thüringen</span>.
          </p>
        </div>
      </div>
    </footer>
  );
}
